var map = {
	"./da.json": "e752",
	"./de.json": "34a7",
	"./en.json": "75d1",
	"./fr.json": "cdda",
	"./nb.json": "1f0f",
	"./nl.json": "4270",
	"./nn.json": "7ce9",
	"./sv.json": "715f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f584";